import React from 'react';
import { connect } from 'react-redux';

import Fallback from '../../components/common/session/Fallback';
import SsapDuplicationFallback from '../../components/common/session/SsapDuplicationFallback';


const FallbackContainer = props => {

    const {
        environment: {
            links: {
                LOGOUT: logout
            },
            stateCode
        },
        history: {
            location: {
                state: {
                    isSsapDuplication = false
                } = {}
            } = {}
        } = {}
    } = props;

    const getFallback = () => {
        switch(true) {
            case isSsapDuplication === true:
                return <SsapDuplicationFallback stateCode = { stateCode } />;
            default:
                return <Fallback { ...{ logout, stateCode } }/>;
        }
    };

    return getFallback();
};


const mapStateToProps = state => ({
    environment: state.common.environment
});
export default connect(mapStateToProps)(FallbackContainer);